import State from './State.js';
import Deck from './Deck.js';

export default class StateStartRound extends State {
    constructor(context) {
        super(context);  //this.context = type of 'Cribbage'
        this.name = 'startRound';
    }
    setup() {

        //reset round points
        this.context.roundNumber += 1;
        this.context.playCount = null;
        this.context.messagePlayer1 = "";
        this.context.messagePlayer2 = "";
        this.context.playerTurn = "";

        //reset cards
        //when to shuffle?
        for (var i = 0; i < this.context.cards.length; i++) {
            let card = this.context.cards[i];
            card.pile = "deck"
            card.pilez = i;
            card.owner = "";
            card.isSelected = false;
            card.showfront = true;
        }
        this.context.sendEvent("cardMoved");

    }
    action(command, value, player) {
        switch (command) {
            case "startround": this.start(player); break;
            case "next": this.start(player); break;
            default: this.unknownCommand(command, value, player);
        }
    }
    getActions(player) {
        let actions = [];
        actions.push({ command: "startround", value: null });
        return actions;
    }
    start() {
        if (this.context.dealer === null) {
            this.context.setState("cut");
        } else {
            //change dealers
            if (this.context.dealer === "player1")
                this.context.dealer = "player2";
            else
                this.context.dealer = "player1";

            this.context.setState("crib");
        }
    }
   
    unknownCommand(command, value, player) {
        this.context.unknownCommand( command, null, player);
    }
    
}